<template lang="pug">

    .field(:class='{ required: isRequired }')
        label(v-bind:for='fieldId' v-if='label !== undefined' ) {{ label }}
        input(
            type='number'
            v-bind:id='fieldId'
            v-bind:disabled='disabled'
            v-bind:readonly='readonly'
            v-bind:max='max'
            v-bind:min='min'
            v-bind:step='step'
            v-model='model'
        )
        slot

</template>

<script>
    import * as R from 'ramda'

    //noinspection ReservedWordAsName
    export default {
        computed: {
            model: {
                get() { return this.value },
                set(value) {
                    R.compose(

                        // Aenderung comitten
                        value => this.$emit('input', value),

                        // ggf. nach Number casten
                        R.ifElse(R.propEq('length', 0),
                            R.always(undefined),
                            Number
                        )

                    )(value)
                }
            }
        },

        data() {
            return {
                fieldId: this.$rndId()
            }
        },

        props: {

            disabled: {
                type: Boolean,
                default: false
            },

            isRequired: {
                type: Boolean,
                default: false
            },

            label: {
                type: String,
            },

            max: {
                type: Number,
                default: 2147483647
            },

            min: {
                type: Number,
                default: -2147483648
            },

            readonly: {
                type: Boolean,
                default: false
            },

            step: {
                type: Number,
                default: 1
            },

            value: {
                required: true
            },

        }
    }

</script>
